import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { FileItem } from '../../models';

@Component({
  selector: 'evi-desktop-file-browser',
  templateUrl: './file-browser.component.html',
  styleUrls: ['./file-browser.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileBrowserComponent {
  public readonly selectFolder = output<FileItem>();
  public readonly backToPreviousFolder = output<number>();

  public loading = input<boolean>(false);
  public path = input<FileItem[]>([]);
  public buttonBackDisabled = input<boolean>(false);

  public onFolderSelection(folder: FileItem): void {
    this.selectFolder.emit(folder);
  }

  public back(length: number): void {
    this.backToPreviousFolder.emit(length);
  }
}
